/** 캐릭터 디자인 포트폴리오 목록 및 상세 슬러그 공통 관리 */

import { sortPortfolioByYear } from './portfolioYearSort'

/** 브랜드 쇼케이스 히어로(상세 2섹션·포트폴리오 2번 카드 공통) */
export const CHARACTER_BRAND_SHOWCASE_IMG =
    '/assets/img/design/character-brand-showcase-codam.png'

export const CHARACTER_DESIGN_PORTFOLIO_PATH = '/codam-design/character-design'

/** @param {string} slug */
export function characterDesignCaseHref(slug) {
    return `${CHARACTER_DESIGN_PORTFOLIO_PATH}/${slug}`
}

/**
 * 포트폴리오 카드 → 상세 (동일 프로젝트 복수 카드 시 linkSlug · 앵커 지원)
 * @param {{ slug?: string, linkSlug?: string, detailHash?: string }} item
 */
export function portfolioCardHref(item) {
    const slug = item.linkSlug ?? item.slug
    if (!slug) return CHARACTER_DESIGN_PORTFOLIO_PATH
    let href = `${CHARACTER_DESIGN_PORTFOLIO_PATH}/${slug}`
    if (item.detailHash) href += `#${item.detailHash}`
    return href
}

export const VALID_CHARACTER_DETAIL_SLUGS = new Set(['brand-ip-mascot'])

/** CODAM 공식 마스코트 상세 페이지 경로 세그먼트 (첫 카드 다른 IP 케이스와 분리) */
export const CODAM_CHARACTER_DETAIL_SLUG = 'codam-mascot'

/**
 * 포트폴리오 카드 데이터
 * @type {Array<{
 *   slug?: string,
 *   title: string,
 *   excerpt: string,
 *   image?: string,
 *   imageAlt?: string,
 *   year?: string,
 *   tags?: string[],
 *   comingSoon?: boolean,
 *   linkSlug?: string,
 *   detailHash?: string,
 * }>}
 */
const characterPortfolioItemsSource = [
    {
        slug: 'brand-ip-mascot',
        title: '브랜드 IP 캐릭터·마스코트 개발',
        excerpt:
            '턴라운드·표정 세트·활용 가이드까지, 웹·SNS·굿즈에 일관 적용 가능한 마스코트 자산을 설계했습니다.',
        image: '/assets/img/design/codam-design-character-section.png',
        imageAlt: '브랜드 IP 캐릭터 디자인 — 포트폴리오 썸네일',
        year: '2026',
        tags: ['캐릭터', 'IP 가이드', '굿즈'],
    },
    {
        slug: CODAM_CHARACTER_DETAIL_SLUG,
        title: '코담 공식 브랜드 마스코트',
        excerpt:
            '코담 공식 브랜드 마스코트의 형태 규격과 포즈 세트, 가이드 및 디지털·굿즈 활용을 정리했습니다.',
        image: CHARACTER_BRAND_SHOWCASE_IMG,
        imageAlt:
            '코담 CODAM 공식 브랜드 마스코트 — 턴라운드·포즈·가이드 및 디지털·굿즈 활용',
        year: '2026',
        tags: ['3D 마스코트', '브랜드 시스템', 'CODAM'],
    },
]

export const characterPortfolioItems = sortPortfolioByYear(characterPortfolioItemsSource)
